<template>
  <div>
    <v-overlay v-if="loading" color="grey" opacity="100">
      <v-progress-circular indeterminate color="primary" x-large class="mb-3"></v-progress-circular>
      <h3>Загрузка списка агентов</h3>
    </v-overlay>
    <div ref="capture" class="container-fluid main-container text-center bg1">
      <div class="agents-title-wrapper">
        <div
          v-if="!loading"
          class="agents-container mx-auto"
          :style="{ maxWidth: `${width}px`, columnGap: `${columnGap}px` }"
        >
          <div
            v-for="(agent, index) in data.agents"
            :key="index"
            class="agent"
            :style="{ padding: `${photoPaddingV}px ${photoPaddingH}px` }"
          >
            <img :src="agent.photo" :style="{ width: `${imgWidth}px` }" class="agent__image" />
            <div class="agent__full-name">
              <span class="font-weight-bold d-block agent__name">{{
                agent.name.split(' ')[0]
              }}</span>
              <span class="font-weight-bold d-block agent__surname">{{
                agent.name.split(' ')[1]
              }}</span>
            </div>
          </div>
        </div>
        <div class="text-center mx-auto title-container" v-if="!loading">
          <h3 class="h3 font-weight-bold text-uppercase">Лучшие специалисты компании</h3>
          <h1 class="h1 font-weight-bold text-uppercase">{{ data.office }}</h1>
          <h4 class="mb-0">по итогам {{ period }} квотного периода</h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopGrid',
  props: ['office', 'width', 'period', 'imgWidth', 'columnGap', 'photoPaddingH', 'photoPaddingV'],
  data() {
    return {
      data: '',
      loading: false,
      url: 'https://weather.matveymatvey.com/gettop',
    };
  },
  watch: {
    office(newValue) {
      this.Gettop(newValue);
    },
  },
  methods: {
    async Gettop(office) {
      this.loading = true;
      await fetch(`${this.url}/${office}`, {
        method: 'GET',
      })
        .then((response) => {
          if (response.status === 500) {
            this.current_user = '500, Ошибка сервера API';
            throw new Error(response.status);
          } else return response.json();
        })
        .then((data) => {
          this.data = data;
          this.loading = false;
        })
        .catch((error) => {
          console.error('There was en error:', error);
          this.loading = false;
        });
    },
  },
  mounted() {
    this.Gettop(this.office);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.agents-title-wrapper {
  display: flex;
  flex-direction: column;
  gap: 100px;
}

.main-container {
  display: flex;
  flex-direction: column;
  height: 915px;
  color: #fff;
  font-weight: 700;
  font-size: 16px;
  justify-content: center;
  align-items: center;
}

.bg1 {
  width: 100%;
  height: 1080px;
  background: url('../assets/bg-2.jpg') !important;
}

.bg2 {
  background-color: #4169e1 !important;
}

.agents-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding-left: 0;
  flex-wrap: wrap;
  row-gap: 40px;
  max-width: 1050px;
  overflow-y: hidden;
}

.agent {
  padding: 10px 20px;
  background-color: #fffafa;
  color: #0f0f0f;
}

.agent__image {
  margin-bottom: 5px;
  height: 285px;
  object-fit: cover;
}

.agent__fullname {
  font-size: 40px;
}

.agent__name {
  font-size: inherit;
}

.agent__surname {
  font-size: inherit;
  line-height: 15px;
}

.title-container {
  bottom: 0;
  left: 50%;
}

.wrapper {
  position: absolute;
  width: 100%;
  min-height: 100%;
  overflow: hidden;
}
</style>
